"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { ProgressProvider } from "./use-progress-context.js";
import { useProgress } from "./use-progress.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-root.tsx
var splitRootProps = createSplitProps();
var ProgressRoot = forwardRef((props, ref) => {
	const [progressProps, localProps] = splitRootProps(props, [
		"defaultValue",
		"formatOptions",
		"id",
		"ids",
		"locale",
		"max",
		"min",
		"onValueChange",
		"orientation",
		"translations",
		"value"
	]);
	const progress = useProgress(progressProps);
	const mergedProps = mergeProps(progress.getRootProps(), localProps);
	return /* @__PURE__ */ jsx(ProgressProvider, {
		value: progress,
		children: /* @__PURE__ */ jsx(ark.div, {
			...mergedProps,
			ref
		})
	});
});
ProgressRoot.displayName = "ProgressRoot";
//#endregion
export { ProgressRoot };
